<template lang="pug">
.message-confirm-modal
  b-modal(v-model="_modalShow" size="lg" no-close-on-backdrop no-close-on-esc @ok="onSend")
    template(#modal-header="{ cancel }")
      .send-message-target-modal-header.d-flex.flex-row.align-items-center
        span.menu-title.flex-grow-1 {{ modalTitle }}
      button.close(type="button" @click="cancel") ×

    //- title
    .mb-0
      span.key-name タイトル
    #title.mb-3
      .mb-0
        span {{ _title }}
    //- text
    .mb-0
      span.key-name 本文
    #text.mb-0
      .mb-0
        span(style="white-space: pre-wrap; word-wrap: break-word;") {{ _text }}

    template(#modal-footer="{ ok, cancel }")
      button.btn.modal-ok-btn(type="button" @click="ok()") OK
      button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import FormLabel from "@/pc/components/forms/FormLabel.vue";

/**
 * ### メッセージ送信確認モーダル
 */
@Component({
  components: {
    FormLabel
  }
})
export default class MessageConfirmModal extends Vue {
  /** モーダル表示可否 */
  @Prop()
  value!: boolean;
  /** モーダルタイトル */
  @Prop()
  modalTitle!: string;
  /** タイトル */
  @Prop()
  title!: string;
  /** 本文 */
  @Prop()
  text!: string;

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _title(): string {
    return this.title;
  }

  get _text(): string {
    return this.text;
  }

  /**
   * ### 送信ボタン押下処理
   *
   * - モーダルを非表示にするか否かは親コンポーネントに移譲する
   */
  public onSend(modalEvent: any): void {
    modalEvent.preventDefault();
    this.$emit("onSend");
    return;
  }
}
</script>
